import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { setOnUnauthorized } from '@/services/api'
import { useAuthStore } from '@/stores/auth.store'
import './style.css'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)

const authStore = useAuthStore()

setOnUnauthorized(() => {
  authStore.clearAuth()
  router.push({ name: 'login' })
})

authStore.init().then(() => {
  app.use(router)
  app.mount('#app')
})
